import { createSelector } from '@ngrx/store';
import { BoelsState, getStoreState } from '../../reducers.index';
import { BoelsCategoryHierarchy } from '@boels/models';
import { CatalogMap, CatalogsState } from '../reducers/catalogs.reducer';
import { findNestedObjRecursive } from '@boels/helpers';

export const selectCatalogs = createSelector(
  getStoreState,
  (state: BoelsState) => state.catalogs,
);

export const selectCatalogsLoading = createSelector(
  selectCatalogs,
  (state: CatalogsState) => state.loading,
);

export const selectCatalogsSuccess = createSelector(
  selectCatalogs,
  (state: CatalogsState) => state.success,
);

export const selectCatalogsError = createSelector(
  selectCatalogs,
  (state: CatalogsState) => state.error,
);

export const selectCatalogsEntities = createSelector(
  selectCatalogs,
  (state: CatalogsState) => state.entities,
);

export const selectParentCategoryforId = (props: {
  culture: string;
  categoryId: string;
}) =>
  createSelector(selectCatalogsEntities, (state: CatalogMap) => {
    const categoryLevel1 = state[props.culture]?.categories[0].subcategories; // level 0 only has one element
    return categoryLevel1?.find((parentCategory: BoelsCategoryHierarchy) =>
      parentCategory?.subcategories?.some(
        (childCategory) => childCategory.id === props.categoryId,
      ),
    );
  });

export const selectCategoryForId = (props: {
  culture: string;
  categoryId: string;
}) =>
  createSelector(selectCatalogsEntities, (state: CatalogMap) => {
    return findNestedObjRecursive(state[props.culture], 'id', props.categoryId);
  });
